import { render, staticRenderFns } from "./PaymentComponent.vue?vue&type=template&id=45801fad&"
import script from "./PaymentComponent.vue?vue&type=script&lang=js&"
export * from "./PaymentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports